/**
 * setSignUpModal.js
 * Written by: Alex Kasemir
 */

import { getWeightedRandom } from 'utils';

export const setSignUpModalStart = () => ({
  type: `SET_SIGN_UP_MODAL_START`,
});

export const setSignUpModalSuccess = (kind) => ({
  type: `SET_SIGN_UP_MODAL_SUCCESS`,
  kind,
});

export const setSignUpModalFailure = (error) => ({
  type: `SET_SIGN_UP_MODAL_FAILURE`,
  error,
});

const MODAL_TYPES = {
  progress: {
    firstWeight: 3,
    weight: 2,
  },
  badge: {
    firstWeight: 1,
    weight: 1,
  },
  topLeaderboard: {
    firstWeight: 1,
    weight: 1,
  },
  score: {
    firstWeight: 1,
    weight: 1,
  },
};

/**
 * Description of the setSignUpModal action
 */
export const setSignUpModal = () => {
  return (dispatch, getState) => {
    dispatch(setSignUpModalStart());
    const lastModalType = getState().extra.alertTypes.signUp;

    const weightObj = {};
    Object.entries(MODAL_TYPES).forEach(([key, val]) => {
      if (lastModalType) {
        if (key !== lastModalType) {
          weightObj[key] = val.weight;
        }
      } else {
        weightObj[key] = val.firstWeight;
      }
    });

    const modalType = getWeightedRandom(weightObj);
    dispatch(setSignUpModalSuccess(modalType));
    return modalType;
  };
};

export default setSignUpModal;
